import HeaderPageBlock from '@ui/Blocks/Shared/HeaderPageBlock';
import { ITBox, QboButton, QboCard, QboModal, QboSimpleDataTable } from '@ui/Components';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { IconButton, Pagination } from '@mui/material';
import NoStatusSection from '@ui/Sections/SystemStatusPage/NoStatusSection';
import RefreshIcon from '@mui/icons-material/Refresh';
import StepperBlock from '@ui/Blocks/Shared/StepperBlock';
import MailboxDeactivationFormSection from '@ui/Sections/MailboxDeactivation/MailboxDeactivationFormSection';
import MailboxDeactivationConfirmSection from '@ui/Sections/MailboxDeactivation/MailboxDeactivationConfirmSection';
import ToolsRequestDetailsSection from '@ui/Sections/ToolsRequestHistoryPage/ToolsRequestDetailsSection';
import useMailboxDeactivationHistory from './pageHooks/useMailboxDeactivationHistory';
import useMailboxDeactivationModal from './pageHooks/useMailboxDeactivationModal';
import useDataService from './pageHooks/useDataService';

export default function MailboxDeactivationPage() {
  const { t } = useTranslation();
  const { tableHeaders } = useDataService();
  const {
    fetching,
    tableData,
    rowsCount,
    pagination,
    selectedRow,
    setSelectedRow,
    setPagination,
    handleRefresh,
  } = useMailboxDeactivationHistory();
  const {
    showModal,
    handleOpenModal,
    handleCloseModal,
    steps,
    stepIcons,
    stepper,
    validateError,
    handleValidate,
    isValidating,
    validateResult,
    formData,
    submitError,
    handleSubmit,
    isSubmitting,
    handleBack,
    form,
  } = useMailboxDeactivationModal({ onClose: handleRefresh });

  const handleChangePage = (_, newPage) => setPagination({ ...pagination, pageIndex: newPage - 1 });

  return (
    <>
      <HeaderPageBlock>{t('mailbox_deactivation.title')}</HeaderPageBlock>
      <QboCard>
        <ITBox className="SystemStatusSection__wrapper" direction="column">
          <ITBox className="SystemStatusSection__create-button">
            <IconButton
              sx={{
                position: 'relative',
                right: '0.7rem',
              }}
              onClick={handleRefresh}>
              <RefreshIcon
                sx={{
                  width: '2rem',
                  height: '2rem',
                }}
              />
            </IconButton>
            &nbsp;
            <QboButton variant="contained" onClick={handleOpenModal}>
              {t('mailbox_deactivation.new_request')}
            </QboButton>
          </ITBox>
        </ITBox>
        <QboCard noPadding isMainWrapper>
          {fetching || !!tableData.length ? (
            <>
              <QboSimpleDataTable
                sx={{ width: '100%' }}
                rows={tableData}
                header={tableHeaders}
                loading={fetching}
                onClickRow={setSelectedRow}
              />{' '}
              {rowsCount && (
                <Pagination
                  sx={{
                    display: 'flex',
                    justifyContent: 'end',
                    margin: '1em',
                    fontSize: '2rem',
                  }}
                  count={Math.ceil(rowsCount / pagination.pageSize)}
                  page={pagination.pageIndex + 1}
                  onChange={handleChangePage}
                  size="large"
                />
              )}
            </>
          ) : (
            <NoStatusSection />
          )}
        </QboCard>
      </QboCard>
      <QboModal
        onClose={handleCloseModal}
        open={showModal}
        title={t('mailbox_deactivation.modal.title')}
        showCloseIcon
        preventOutsideClick>
        <StepperBlock
          steps={steps}
          icons={stepIcons}
          hideLabel
          activeStepAlt={stepper.activeStep}
          isStepOptionalAlt={stepper.isStepOptional}
          isStepSkippedAlt={stepper.isStepOptional}>
          <MailboxDeactivationFormSection
            onValidate={handleValidate}
            isValidating={isValidating}
            errorMessage={validateError}
            form={form}
          />
          <MailboxDeactivationConfirmSection
            isSubmitting={isSubmitting}
            errorMessage={submitError}
            validateResult={validateResult}
            formData={formData}
            onSubmit={handleSubmit}
            onBack={handleBack}
          />
        </StepperBlock>
      </QboModal>
      {!!selectedRow && (
        <ToolsRequestDetailsSection
          jobId={selectedRow.id}
          jobType={selectedRow['job-type-id']}
          handleOnClose={() => setSelectedRow(undefined)}
        />
      )}
    </>
  );
}
